module.exports = __webpack_public_path__ + "media/img/external-link-button-1edf06faf1e7be516f920e425362fe89.svg";